import {
    RESET_2FA_STORE_TOKEN,
    RESET_2FA_TOKEN_INVALIDATED,
    RESET_2FA_INITIATE_DOWNLOAD_QR_IMAGE,
    RESET_2FA_QR_IMAGE_DOWNLOADED,
    RESET_2FA_TOTP_TOKEN_VALIDITY_CHANGED,
} from '../actions/twoFAResets';

export const defaultState = {
    resetToken: null,
    downloadingQrImage: false,
    qrImage: null,
    totpTokenInvalid: false,
};

const twoFAResets = (state = defaultState, action = undefined) => {
    switch (action.type) {
        case RESET_2FA_STORE_TOKEN:
            return { ...state, resetToken: action.payload.token };
        case RESET_2FA_TOKEN_INVALIDATED:
            return { ...state, resetToken: null };
        case RESET_2FA_INITIATE_DOWNLOAD_QR_IMAGE:
            return { ...state, downloadingQrImage: true };
        case RESET_2FA_QR_IMAGE_DOWNLOADED:
            return { ...state, downloadingQrImage: false, qrImage: action.payload.qrImage };
        case RESET_2FA_TOTP_TOKEN_VALIDITY_CHANGED:
            return { ...state, totpTokenInvalid: action.payload.invalid };
        default:
            return state;
    }
};

export default twoFAResets;
